import { TenantDto, TenantsApi } from '../../../api-client';
import { useQuery, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';

const QUERY_KEY = 'tenants';

export const useGetTenants = (
  tenantsApi: TenantsApi,
  onError: (err: ErrorResponse) => void,
): UseQueryResult<TenantDto[]> =>
  useQuery([QUERY_KEY], async () => tenantsApi.getTenants(0, 1000).then((res) => res.data), {
    keepPreviousData: false,
    retry: false,
    onError,
  });
